import { generateMonthProductionPlan } from "../../actions/pdf";
import { handleError, handleSuccess } from "../../helpers/utils";

export const generateProductionPlanPDF = (priorityOrder, month, eventBiases, userName) => {
    const namesString = priorityOrder.map(obj => obj.name)?.join(' - ');
    
    // Helper function to get day name in Spanish
    const getDayName = (dateString) => {
        const daysOfWeek = ["Domingo", "Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado"];
        const date = new Date(dateString);
        return daysOfWeek[date.getUTCDay()];
    };

    // Helper function to get day and month in Spanish
    const getFormattedDate = (dateString) => {
        const monthsOfYear = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"];
        const date = new Date(dateString);
        const day = date.getUTCDate();
        const month = monthsOfYear[date.getUTCMonth()];
        return `${day} de ${month}`;
    };

    // Create a map from date to orders
    const dateOrdersMap = eventBiases.reduce((acc, order) => {
        const date = order.start;
        if (!acc[date] ) {
            acc[date] = [];
        }
        acc[date].push({
            name: order.title,
            area: order.extendedProps.currentArea,
            days: order.extendedProps.bias.areas[order.extendedProps.currentArea].days
        });
        return acc;
    }, {});

    // Generate days_col1 and days_col2 arrays
    const daysArray = Object.keys(dateOrdersMap).map((date, index) => {
        const dateObj = new Date(date);
        return {
            id: index + 1,
            day: getDayName(dateObj),
            date: getFormattedDate(dateObj),
            orders: dateOrdersMap[date]
        };
    });

    const finalArray = daysArray.filter(e => e.date?.includes(month));

    // Calculate the midpoint, rounding up
    const midpoint = Math.ceil(finalArray.length / 2);

    const days_col1 = finalArray.slice(0, midpoint);
    const days_col2 = finalArray.slice(midpoint);

    const payloadPDF = {
        file_name: `Plan-de-produccion-${userName}-${month}`,
        month: month?.toUpperCase(),
        area: namesString?.toUpperCase(),
        days_col1: days_col1,
        days_col2: days_col2,
    };
    generateMonthProductionPlan(payloadPDF)
        .then(() => {
            handleSuccess('Reporte generado');
        })
        .catch((error) => {
            handleError(
                error,
                'Ocurrió un error al intentar generar el reporte'
            );
        });
};